// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"3864ea566282af48c1a3","584":"080189ea0ab638fdb55a","945":"90e1d991748ae777eb98"}[chunkId] + ".chunk.js";
};